import "core-js/modules/es6.array.sort";
import _defineProperty from "E:\\RiderProjects\\pdcweb\\node_modules\\@babel\\runtime-corejs2/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { dateFormat, SortField } from "../../utils/helper";
var that;
export default {
  name: 'frequency',
  data: function data() {
    var _query;

    return {
      pickerOptions0: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      balanceArr: [],
      frequencys: [],
      pageCount: 1,
      multipleSelection: [],
      loading: false,
      query: (_query = {
        startDate: '',
        endDate: '',
        daterange: ''
      }, _defineProperty(_query, "daterange", ''), _defineProperty(_query, "balanceId", 0), _defineProperty(_query, "PageIndex", 1), _defineProperty(_query, "PageSize", 15), _query),
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
        },
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  created: function created() {
    var end = new Date();
    var start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.query.daterange = [start, end];
    this.getData();
    this.getBalance();
  },
  methods: {
    getData: function getData() {
      var _this = this;

      if (this.query.daterange == null) {
        this.$notify.warning('日期不能为空!!!');
        return;
      }

      this.query.startDate = new Date(dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd 08:00:00'));
      this.query.endDate = new Date(dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd 08:00:00'));
      var userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
      this.query.CreateUserId = userInfo.id;
      this.query.UserName = userInfo.realName;
      this.$zybhttp.post('DataInquiry/GetStartStopRecord', this.query).then(function (res) {
        if (res.data.status == 0) {
          res = res.data;
          var d = res.data.list;
          var newdata = d.sort(SortField('id', 'desc')); // for (var i = 0; i < newdata.length; i++) {
          //     newdata[i]['balanceName'] = this.getBalanceNames(newdata[i]['balanceId']);
          // }

          _this.frequencys = newdata;
          _this.pageCount = res.data.total || 0;
        } else {
          _this.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this.$notify.error('网络异常！获取列表失败！');
      });
    },
    getBalance: function getBalance() {
      var _this2 = this;

      var userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
      var serach = {};
      this.$zybhttp.post('Balance/GetList', {
        Field1: userInfo.userType,
        Field2: userInfo.id + '',
        Field3: userInfo.realName
      }).then(function (res) {
        if (res.data.status == 0) {
          var d = res.data.data.list;
          _this2.balanceArr = [{
            id: 0,
            name: '全部'
          }].concat(d).sort(SortField('id', 'asc'));

          _this2.getData();
        } else {
          _this2.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this2.$notify.error('网络异常！获取列表失败！');
      });
    },
    handlePageChange: function handlePageChange(val) {
      this.$set(this.query, 'PageIndex', val);
      this.getData();
    },
    indexMethod: function indexMethod(index) {
      return index + 1;
    }
  }
};